import {
    FaArrowRight,
    FaBuilding,
    FaCode,
    FaLaptopCode,
    FaMobileAlt,
    FaPalette,
    FaShoppingCart,
} from "react-icons/fa";
import "./Services.css";


const services = [
  {
    icon: <FaCode />,
    title: "Custom Software Development",
    desc: "Tailor-made software solutions designed to solve complex business challenges with scalability and performance in mind.",
  },
  {
    icon: <FaLaptopCode />,
    title: "Web Application Development",
    desc: "High-performance, secure, and scalable web applications built with modern technologies and clean architecture.",
  },
  {
    icon: <FaMobileAlt />,
    title: "Mobile App Development",
    desc: "Feature-rich Android & iOS applications delivering seamless user experiences and long-term scalability.",
  },
  {
    icon: <FaPalette />,
    title: "UI / UX Design",
    desc: "Premium user interface and experience design focused on usability, aesthetics, and conversion optimization.",
  },
  {
    icon: <FaShoppingCart />,
    title: "E-Commerce Solutions",
    desc: "Robust e-commerce platforms with smooth user journeys, secure payments, and scalable infrastructure.",
  },
  {
    icon: <FaBuilding />,
    title: "Enterprise & SaaS Solutions",
    desc: "Enterprise-grade and SaaS platforms designed for performance, security, and future-ready growth.",
  },
];

const Services = () => {
  return (
    <section className="oglitz-home-services">
      <div className="oglitz-home-services-inner">
        <span className="oglitz-home-services-badge">Our Services</span>

        <h2 className="oglitz-home-services-title">
          Digital Solutions Built for <span>Growth & Scale</span>
        </h2>

        <p className="oglitz-home-services-desc">
          We design and develop premium digital products — from custom software
          to enterprise platforms — tailored to your business goals.
        </p>

        <div className="oglitz-home-services-grid">
          {services.map((service, index) => (
            <div className="oglitz-home-service-card" key={index}>
              <div className="oglitz-home-service-icon">{service.icon}</div>

              <h3>{service.title}</h3>
              <p>{service.desc}</p>

              <a href="/start-project" className="oglitz-home-service-link">
                Get Started <FaArrowRight />
              </a>
            </div>
          ))}
        </div>

        <div className="oglitz-home-services-cta">
          <a href="/services" className="oglitz-home-services-btn">
            View All Services <FaArrowRight />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
